"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function IntroductionWhoWeAre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="introductionwhoweare" className="bg-background py-16 md:py-24 lg:py-32">
      <div ref={ref} className={`container mx-auto max-w-3xl px-6 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="space-y-12">
          {}
          <div className="space-y-4 text-center md:text-left">
            <h1 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="font-sans text-sm text-muted-foreground">
              Effective Date: 20 June 2026
            </p>
          </div>

          {}
          <div className="space-y-5">
            <h2 className="font-default text-2xl font-semibold text-primary">
              1. Introduction
            </h2>
            <div className="font-sans space-y-4 text-foreground/80 leading-relaxed">
              <p>
                Coastline Air Conditioning Services Ltd ({"we"}, {"our"}, or {"us"}) is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, store, and protect your personal information when you contact us, use our services, visit our website, or otherwise interact with us.
              </p>
              <p>
                We comply with the UK General Data Protection Regulation (UK GDPR), the Data Protection Act 2018, and other applicable privacy laws.
              </p>
            </div>
          </div>

          <Separator className="my-8" />

          {}
          <div className="space-y-6">
            <h2 className="font-default text-2xl font-semibold text-primary">
              2. Who We Are
            </h2>
            <p className="font-sans text-foreground/80 leading-relaxed">
              Coastline Air Conditioning Services Ltd is the data controller responsible for your personal data.
            </p>

            <Card className="bg-muted/30 border-border/50 shadow-sm">
              <CardContent className="p-6 sm:p-8 space-y-6">
                <h3 className="font-default text-lg font-semibold text-foreground">
                  Contact Details
                </h3>
                
                <div className="space-y-4">
                  <address className="font-sans not-italic text-foreground/80 space-y-1">
                    <p className="font-bold text-foreground text-base">
                      Coastline Air Conditioning Services Ltd
                    </p>
                    <p>Merrydown</p>
                    <p>Kingston Lane</p>
                    <p>East Preston</p>
                    <p>BN16 1RP</p>
                  </address>
                  
                  <div className="font-sans flex items-center gap-2 pt-2">
                    <span className="font-semibold text-foreground">Email:</span>
                    <Link to="mailto:info@coastline-services.co.uk" className="text-primary hover:underline transition-colors">
                      info@coastline-services.co.uk
                    </Link>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}